// extracted by mini-css-extract-plugin
export var category = "Accordion-module--category--3931e";
export var closed = "Accordion-module--closed--a4d9e";
export var container = "Accordion-module--container--09e1f";
export var content = "Accordion-module--content--73ce8";
export var title = "Accordion-module--title--d0ae0";
export var titleBar = "Accordion-module--titleBar--e1d85";
export var titleBarText = "Accordion-module--titleBarText--99342";
export var toggleButton = "Accordion-module--toggleButton--da815";